var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v("Создать спрос")])]),_c('CCardBody',[_c('DemandUpsertForm',{on:{"success":function($event){return _vm.$router.push("/demands")}}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }